module.exports = __webpack_public_path__ + "static/media/LogoV3NoWhite.a0a1d0cd.svg";